(ns common.schema.entities.rotation-period-override.core
  (:require
   [common.schema.entities.rotation-period-override.permissions :as permissions]
   [common.schema.entities.rotation-period-override.schema :as schema]))

(def entity-type-definition
  {:entity-type                  :entity.type/rotation-period-override
   :schema                       schema/schema
   :name                         {:en "Rotation period override"}
   :plural                       {:en "Rotation period overrides"}
   :icon                         :fa-code-branch
   ;; DEV-8200: was the rotation period key, which is no longer written. An
   ;; override with only the new reference would otherwise display as blank.
   :display-name-template        "{{rotation-period-override/rotation-period}}"
   :display-name/depends-on      [:rotation-period-override/rotation-period]
   :permissions                  {:creatable?   true
                                  :disableable? true}
   :read-permissions-check-fn    permissions/read-permissions?
   :disable-permissions-check-fn permissions/disable-permissions?})
